import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Settings from '@material-ui/icons/Settings';
import BrandMark from 'components/core/BrandMark';
import PropTypes from 'prop-types';

const styles = {
  '@keyframes breathe': {
    '0%, 100%': { transform: 'scale(1)', opacity: 0.55 },
    '50%': { transform: 'scale(1.12)', opacity: 0.9 },
  },
  '@keyframes rise': {
    from: { opacity: 0, transform: 'translateY(18px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
  '@keyframes drift': {
    '0%, 100%': { transform: 'translate3d(0, 0, 0)' },
    '50%': { transform: 'translate3d(12px, -10px, 0)' },
  },
  root: {
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 20px',
    boxSizing: 'border-box',
    direction: 'rtl',
    position: 'relative',
    overflow: 'hidden',
    background:
      'radial-gradient(ellipse 90% 70% at 80% 10%, rgba(0, 168, 188, 0.18), transparent 55%),' +
      'radial-gradient(ellipse 70% 60% at 10% 90%, rgba(54, 53, 89, 0.22), transparent 50%),' +
      'linear-gradient(160deg, #f4f8fa 0%, #e8f2f5 42%, #dce8ee 100%)',
  },
  glow: {
    position: 'absolute',
    width: 420,
    height: 420,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(0, 168, 188, 0.16) 0%, transparent 70%)',
    top: '8%',
    left: '6%',
    animation: 'drift 14s ease-in-out infinite',
    pointerEvents: 'none',
  },
  glowSecondary: {
    position: 'absolute',
    width: 360,
    height: 360,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(54, 53, 89, 0.12) 0%, transparent 70%)',
    bottom: '6%',
    right: '8%',
    animation: 'drift 18s ease-in-out infinite reverse',
    pointerEvents: 'none',
  },
  pattern: {
    position: 'absolute',
    inset: 0,
    opacity: 0.35,
    backgroundImage:
      'linear-gradient(rgba(0, 168, 188, 0.06) 1px, transparent 1px),' +
      'linear-gradient(90deg, rgba(0, 168, 188, 0.06) 1px, transparent 1px)',
    backgroundSize: '48px 48px',
    maskImage: 'radial-gradient(ellipse 70% 60% at 50% 45%, #000 20%, transparent 75%)',
    WebkitMaskImage: 'radial-gradient(ellipse 70% 60% at 50% 45%, #000 20%, transparent 75%)',
    pointerEvents: 'none',
  },
  content: {
    position: 'relative',
    zIndex: 1,
    width: '100%',
    maxWidth: 720,
    textAlign: 'center',
    animation: 'rise 0.7s ease-out both',
  },
  brand: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 36,
  },
  statusRing: {
    width: 72,
    height: 72,
    margin: '0 auto 28px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(255, 255, 255, 0.72)',
    border: '1px solid rgba(0, 168, 188, 0.28)',
    boxShadow: '0 12px 40px rgba(27, 42, 74, 0.08)',
    position: 'relative',
  },
  pulse: {
    position: 'absolute',
    inset: -6,
    borderRadius: '50%',
    border: '2px solid rgba(0, 168, 188, 0.35)',
    animation: 'breathe 2.4s ease-in-out infinite',
  },
  gear: {
    fontSize: 28,
    color: '#00A8BC',
  },
  title: {
    margin: '0 0 18px',
    fontSize: 15,
    fontWeight: 500,
    letterSpacing: '0.04em',
    color: '#00A8BC',
  },
  headline: {
    margin: 0,
    fontSize: 22,
    lineHeight: 1.85,
    fontWeight: 500,
    color: '#2a3350',
    maxWidth: 640,
    marginLeft: 'auto',
    marginRight: 'auto',
    '@media (max-width: 600px)': {
      fontSize: 17,
      lineHeight: 1.8,
    },
  },
  resume: {
    marginTop: 36,
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 6,
    padding: '16px 28px',
    background: 'rgba(255, 255, 255, 0.78)',
    border: '1px solid rgba(0, 168, 188, 0.22)',
    borderRadius: 14,
    boxShadow: '0 8px 28px rgba(27, 42, 74, 0.06)',
  },
  resumeLabel: {
    fontSize: 13,
    color: '#6b7288',
    margin: 0,
  },
  resumeTime: {
    margin: 0,
    fontSize: 28,
    fontWeight: 600,
    color: '#363559',
    letterSpacing: '0.02em',
    '@media (max-width: 600px)': {
      fontSize: 22,
    },
  },
};

const Maintenance = ({ classes }) => (
  <div className={classes.root}>
    <div className={classes.glow} aria-hidden="true" />
    <div className={classes.glowSecondary} aria-hidden="true" />
    <div className={classes.pattern} aria-hidden="true" />

    <div className={classes.content}>
      <div className={classes.brand}>
        <BrandMark height={56} />
      </div>

      <div className={classes.statusRing} aria-hidden="true">
        <span className={classes.pulse} />
        <Settings className={classes.gear} />
      </div>

      <p className={classes.title}>صيانة مؤقتة</p>

      <h1 className={classes.headline}>
        نود إشعاركم بتوقف منصة مساند مؤقتًا لإجراء أعمال الصيانة اللازمة، ومن المتوقع استئناف
        الخدمات غدًا في تمام الساعة 7 صباحًا. نشكر لكم تفهمكم.
      </h1>

      <div className={classes.resume}>
        <p className={classes.resumeLabel}>موعد استئناف الخدمة</p>
        <p className={classes.resumeTime}>7:00 صباحًا</p>
      </div>
    </div>
  </div>
);

Maintenance.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Maintenance);
